module.exports = __webpack_public_path__ + "static/media/trackntone_1024.2177de90.png";